import { makeStyles } from "@material-ui/core";
import React from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import Color from "../../styles/Color";

const styles = makeStyles(theme => {
    return {
        containerEditor: {
            borderRadius: 5,
            boxShadow: "1px 0 6px 0 #efefef",
            border: "1px solid #e0e0e0",
            overflow: "hidden",
            minHeight: 300,
            "& .ql-toolbar": {
                height: 50,
                [theme.breakpoints.down("md")]: {
                    minHeight: 120,
                },
                border: "none",
                borderBottom: "1px solid #e0e0e0",
                background: "#fafafa",
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
            },
            "& .ql-toolbar > .ql-formats > *": {
                display: "flex",
                alignItems: "center",
                boxShadow: "0 0 1px 0 #b0b0b0",
            },
            "& .ql-picker-options .ql-picker-item.ql-selected, & .ql-picker-options .ql-picker-item:hover": {
                color: Color.secondary + " !important",
            },
            "& .ql-picker-options .ql-picker-item.ql-selected .ql-stroke, & .ql-picker-options .ql-picker-item:hover .ql-stroke": {
                color: Color.secondary + " !important",
                stroke: Color.secondary + " !important",
            },
            "& .ql-picker-label.ql-active, & .ql-bold.ql-active": {
                color: Color.secondary + " !important",
            },
            "& .ql-picker-label.ql-active polygon.ql-stroke, & .ql-bold.ql-active .ql-stroke, & .ql-italic.ql-active .ql-stroke, & .ql-underline.ql-active .ql-stroke, & .ql-strike.ql-active .ql-fill, & .ql-picker-label.ql-active": {
                stroke: Color.secondary + " !important",
            },
            "& .ql-list.ql-active .ql-stroke, & .ql-code-block.ql-active polyline.ql-even.ql-stroke, & .ql-link.ql-active .ql-even.ql-stroke,& .ql-picker-label.ql-active polyline.ql-stroke, & .ql-picker-label.ql-active line.ql-stroke:not(.ql-color-label)": {
                stroke: Color.secondary + " !important",
            },
            "& .ql-picker-label.ql-active[data-value]": {
                stroke: "initial !important",
            },
            "& .ql-strike.ql-active .ql-fill, & .ql-blockquote.ql-active .ql-fill": {
                stroke: Color.secondary + " !important",
                fill: Color.secondary + " !important",
            },
            "& .ql-container": {
                border: "none",
            },
        },
    };
});

var toolbarOptions = [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike"], // toggled buttons
    // [ { 'direction': 'rtl' }],
    [{ color: [] }, { background: [] }], // dropdown with defaults from theme

    // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ align: [] }, { list: "ordered" }, { list: "bullet" }],
    // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    // [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    ["link", "image", "blockquote", "code-block"],
    // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown

    // [{ 'font': [] }],

    ["clean"], // remove formatting button
];

const Block = Quill.import("blots/block");
Block.tagName = "div";
Quill.register(Block);

export default function TextEditor({ value = "", onChange = () => {}, error = "" }) {
    const classStyle = styles();
    return (
        <>
            <ReactQuill
                className={classStyle.containerEditor}
                modules={{
                    toolbar: toolbarOptions,
                }}
                theme="snow"
                value={value}
                onChange={onChange}
            />
            <div className="text-danger mt-2">{error}</div>
        </>
    );
}
